import { Fragment } from 'react';

export interface StudentPhotoProps {
  defaultPhoto?: string | null;
}

export default function StudentPhoto(props: StudentPhotoProps) {
  const { defaultPhoto } = props;
  return (
    <Fragment>
      <div className="image-square-container">
        <div className="image-square">
          <img
            src={defaultPhoto || '/images/no-photos.png'}
            className="img img-responsive full-width"
            alt="student"
          />
        </div>
      </div>
    </Fragment>
  );
}
